import { createSlice } from "@reduxjs/toolkit";

export const AuthSlice = createSlice({
    name:"user",
    initialState:{
        user : null
    },
    reducers:{
        login:(state,action) => {
            state.user = action.payload;
        },
        logout:(state) => {
            state.user = null;
        }
    }
});

export const {login,logout} = AuthSlice.actions;

export const selectUser = (state) => state.user.user;

export const selectToken = (state) => state.user.user.api_key;

export default AuthSlice.reducer;